export default __webpack_public_path__ + "47c85bd5e4de3771998c0d377108d471.png";